import React from 'react';
import { Link } from 'react-router';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import Block from '../../../../../ui/block';
import { OtherProfileLinks } from './components/other-profile-links';
import classes from './profile-links.scss';
export const ProfileLinks = ({
  passwordNotSet
}) => {
  return /*#__PURE__*/React.createElement(Block, {
    className: classes['links-block']
  }, /*#__PURE__*/React.createElement("ul", {
    className: classes['profile-links']
  }, /*#__PURE__*/React.createElement(Link, {
    to: APP_ROUTES.PROFILE_SETTINGS,
    className: classes.link,
    activeClassName: classes.active,
    "data-tab": "ProfileSettings"
  }, "Profile settings"), /*#__PURE__*/React.createElement(OtherProfileLinks, {
    passwordNotSet: passwordNotSet
  })));
};